import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#CCDFD6",
    border: '1px solid #007842',
    color: '#717E78',
    opacity: 0.7,
    fontSize: 9,
    fontWeight: 500,
    padding: 2,
    fontFamily: "Open Sans"
  }
}));